import React from 'react';
import { Helmet } from 'react-helmet';
import Intro from './InforCSI/IntroCarousel';
import CSIOverview from './InforCSI/CSIOverview';
import CSIServices from './InforCSI/CSIServices';
import CSICapabilities from './InforCSI/CSICapabilities';
import CSIIndustries from './InforCSI/Industries';
import CSIWhyChoose from './InforCSI/WhyChoose';
import CSIFAQ from './InforCSI/FAQ';
import CTASection from './InforCSI/CTA';

const InforCSIComponent = () => {
  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>PT KCS Tech | Infor CloudSuite Industrial (CSI) ERP Solutions & Consulting</title>
        <meta
          name="description"
          content="Accelerate discrete and engineer-to-order manufacturing with PT KCS Tech's certified Infor CloudSuite Industrial (SyteLine) ERP services: end-to-end implementation, cloud migration, Mongoose customization, and 24/7 global support."
        />
        <meta
          name="keywords"
          content="Infor CSI, Infor CloudSuite Industrial, Infor SyteLine, SyteLine ERP, Infor ERP consulting, manufacturing ERP, discrete manufacturing, ERP implementation, PT KCS Tech"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="PT KCS Tech | Infor CloudSuite Industrial (CSI) ERP Solutions" />
        <meta
          property="og:description"
          content="Certified Infor Alliance Partner delivering turnkey Infor CloudSuite Industrial (SyteLine) implementations, AWS cloud migrations, and continuous enterprise optimization."
        />
        <meta property="og:image" content="https://www.ptkcs.com/static/media/csi_infographic.8c959673ee11f42da79d.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="PT KCS Tech | Infor CloudSuite Industrial (CSI) ERP Solutions" />
        <meta
          name="twitter:description"
          content="Certified Infor Alliance Partner delivering turnkey Infor CloudSuite Industrial (SyteLine) implementations, AWS cloud migrations, and continuous enterprise optimization."
        />
        <meta name="twitter:image" content="https://www.ptkcs.com/static/media/csi_infographic.8c959673ee11f42da79d.png" />

        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS Tech" />
      </Helmet>

      <main
        className="infor-csi-page min-h-screen font-satoshi selection:bg-blue-100 selection:text-blue-900"
        style={{ backgroundColor: '#FFFFFF', color: '#0F172A' }}
      >
        <Intro />
        <CSIOverview />
        <CSIServices />
        {/* <CSICapabilities /> */}
        <CSIIndustries />
        {/* <CSIWhyChoose /> */}
        <CSIFAQ />
        <CTASection />
      </main>
    </>
  );
};

export default InforCSIComponent;
